import {Injectable} from '@angular/core';
import {INDRAApiService} from '@ibe.services/api.indra.service';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {MOCK_STATUS, MOCK_URL_SEATMAP, SEATMAP_PACK_SELECTED_URL_EXTENSION, SEATMAP_SEGMENT_URL_EXTENSION, URL_BFM_PNRS_LIST} from '@ibe.config';
import {INDRACabin} from '@ibe.models/seatmap.indra.model.lib';
import {FlightEquipment, FlightEquipmentEnum} from '@ibe.components/shared/_models/enums/flight-equipment.enum';
import {map} from 'rxjs/operators';
import {Seatmap} from '@ibe.models/seatmap.model.lib';

@Injectable({
	providedIn: 'root'
})
export class INDRASeatmapService {

	constructor(private api: INDRAApiService, private http: HttpClient) {
	}

	public INDRA_getSeatmap(pnr: string, segment: string, packCode: string): Observable<any> {
		if (MOCK_STATUS.SEAT_MAP) {
			return this.http.get<any>(MOCK_URL_SEATMAP);
		} else {
			if (packCode) {
				return this.api.INDRA_get<any>(URL_BFM_PNRS_LIST + '/' + pnr + SEATMAP_SEGMENT_URL_EXTENSION + segment + SEATMAP_PACK_SELECTED_URL_EXTENSION + packCode);
			} else {
				return this.api.INDRA_get<any>(URL_BFM_PNRS_LIST + '/' + pnr + SEATMAP_SEGMENT_URL_EXTENSION + segment);
			}
		}
	}

	public INDRA_getCabinTemplateURL(aircraftFile: string): Observable<Seatmap> {
	  const url = `./assets/data/${aircraftFile}`;
		if (aircraftFile) {
			return this.http.get(url).pipe(
				map((response: any) => response as Seatmap)
			);
		}

		// return empty cabins if no mock for plane
		return of(
			{cabins: [], currency: ''} as Seatmap
		);
	}
}
